import { render, staticRenderFns } from "./GiftPackaging.vue?vue&type=template&id=364dacef&scoped=true"
import script from "./GiftPackaging.vue?vue&type=script&lang=js"
export * from "./GiftPackaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364dacef",
  null
  
)

export default component.exports